<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'userAdmins.editAdminHeader' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close(false)" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form" (submit)="submit()" class="form">
      <div class="form-field">
        <label class="field-label">{{'userAdmins.email' | translate}}</label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="email" type="text" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['email'])">{{'fieldRequired' | translate}}</mat-error>
          <mat-error *ngIf="form.hasError('email', ['email'])">{{'emailInvalid' | translate}}</mat-error>
        </mat-form-field>
      </div>
      <div class="form-field">
        <label class="field-label">{{'userAdmins.role' | translate}}</label>
        <mat-form-field appearance="outline">
          <mat-select formControlName="role" [errorStateMatcher]="errorStateMatcher">
            <mat-option value="SUPER_ADMIN" *ngIf="auth.isSuperAdmin">SUPER_ADMIN</mat-option>
            <mat-option value="RESELLER" *ngIf="auth.isSuperAdmin || auth.isReseller">RESELLER</mat-option>
            <mat-option value="GROUP_MANAGER" *ngIf="auth.isSuperAdmin || auth.isGroupManager || auth.isReseller">GROUP_MANAGER</mat-option>
            <mat-option value="COMPANY_MANAGER">COMPANY_MANAGER</mat-option>
          </mat-select>
          <mat-error *ngIf="form.hasError('required', ['role'])">{{'fieldRequired' | translate}}</mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close(false)" [disabled]="sendingRequest">{{'cancel' | translate}}</button>
    <button mat-raised-button color="primary" type="button" (click)="submit()" [disabled]="sendingRequest">{{'save' | translate}}</button>
  </footer>
</div>
